<template>
    <project-step-container
            prev-to="js_go_broad_to_go_narrow_12"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
            :next-disabled="Object.keys(form.career).length === 0"
    >
        <b-row class="first-form">
            <b-col cols="12" class="simple-text" tabindex="0">
              {{getMessage(13, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3 text-center">
            <b-col :key="index" v-for="(topIdea, index) in topIdeasList" cols="12" class="button-next">
                <b-button :disabled="onDisabledCareers(topIdea.key)" value="0" name="white"
                          variant="secondary" class="square" block size="lg"
                          v-bind:class="{ active: form.career.key === topIdea.key, isCareerEntrep: isJACareerEntrepreApp} "
                          v-on:click="select(topIdea)">
                    <span>{{topIdea.value}}</span>
                </b-button>
            </b-col>
        </b-row>

    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import {Steps} from "../Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    const Careers = Object.freeze({
        FIRSTCAREER: 0,
        SECONDCAREER: 1,
        THIRDCAREER: 2,
    })

    export default {
        name: "GoBroadToGoNarrow13",
        components: {ProjectStepContainer},
        props: ['items'],
        data() {
            return {
                step: Steps.FORM_CAREER,
                urlNextProject: 'js_rapid_experiments_with_customers_14',
                form: {
                    career: {},
                    careersSelected: [],
                    careersTextSelected:[]
                },
                topIdeasList: {
                    firstIdea: "",
                    secondIdea: "",
                    thirdIdea: ""
                },
                careerSelected: "",
                disabledCareers: [],
                index: '',
            }
        },
        created() {
            this.Careers = Careers
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            this.topIdeasList = [
                {
                    key: Careers.FIRSTCAREER,
                    value: forms[Steps.FORM_TOP_IDEAS].firstIdea
                },
                {
                    key: Careers.SECONDCAREER,
                    value: forms[Steps.FORM_TOP_IDEAS].secondIdea
                },
                {
                    key: Careers.THIRDCAREER,
                    value: forms[Steps.FORM_TOP_IDEAS].thirdIdea
                }
            ]


            if (forms[Steps.FORM_INTERVIEW_RESULTS] && 'disabledCareers' in forms[Steps.FORM_INTERVIEW_RESULTS]
            ) {
                this.disabledCareers = forms[Steps.FORM_INTERVIEW_RESULTS].disabledCareers
                this.form.careersSelected = this.disabledCareers
            }
            if (forms[Steps.FORM_EXPERIENCE_RESULTS] && 'disabledCareers' in forms[Steps.FORM_EXPERIENCE_RESULTS]) {
                this.disabledCareers = [...new Set([...forms[Steps.FORM_INTERVIEW_RESULTS].disabledCareers, ...forms[Steps.FORM_EXPERIENCE_RESULTS].disabledCareers])];
                this.form.careersSelected = this.disabledCareers
            }
        },
        methods: {
            select(career) {
                this.form.career = career
                this.careerSelected = this.form.career
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                this.form.careersSelected.push(this.careerSelected.key)
                this.form.careersSelected.forEach(career =>{
                    this.form.careersTextSelected.push(this.topIdeasList.find(element => element.key === career))
                })

                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            onDisabledCareers(currentCareer) {
                return this.form.careersSelected.includes(currentCareer)
            },
            redirection() {
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    +for_breakpoint(xs)
        .font-size
            .emotion-content
                padding-right: 2px !important
                padding-left: 2px !important

    .button-row-cover
        margin-top -20px
        padding-bottom 28px

    .disabledButton
        border: 1px solid #999999
        background-color: #cccccc
        color: #666666
        pointer-events: none
</style>
